// extracted by mini-css-extract-plugin
export default {"container":"WorkspaceCreate_container__rsJln","link":"WorkspaceCreate_link__ewqCv"};